module.exports = __webpack_public_path__ + "static/img/11-2.dafd91d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/11-2.jpg
// module id = Goro
// module chunks = 0